import { create } from "zustand";
import { persist } from "zustand/middleware";

// `Date.now()` 로 바꾸지 말 것 — 새 기기·새 계정의 뱃지가 무조건 0 이 된다(모수인
// 대시보드 이력이 전부 과거 시각이라 통째로 읽음 처리된다).
const NEVER_SEEN = 0;

// 계정별로 가른다. 한 브라우저를 여러 사람이 쓰는 관제 PC 에서, 시각을 하나만 두면
// 앞사람이 알림함을 연 순간 뒷사람 뱃지가 0 이 된다.
interface AlarmInboxState {
  lastSeenByUser: Record<string, number>;
}

interface AlarmInboxActions {
  markSeen: (username: string) => void;
}

type AlarmInboxStore = AlarmInboxState & AlarmInboxActions;

// 쓰기는 `markSeen` 하나뿐이어야 한다. 로그인 시점에 초기값을 심으면 렌더 중 스토어가
// 갱신돼 React 가 경고한다 — 이 훅을 헤더 벨과 하단바 FAB 이 동시에 쓴다.
export const useAlarmInboxStore = create<AlarmInboxStore>()(
  persist(
    (set) => ({
      lastSeenByUser: {},
      markSeen: (username) =>
        set((s) => ({ lastSeenByUser: { ...s.lastSeenByUser, [username]: Date.now() } })),
    }),
    {
      name: "safers.alarm-inbox",
      // v1 은 계정 구분이 없는 `{ lastSeenAt }` 였다. 누구 것인지 알 수 없어 버린다.
      version: 2,
      migrate: () => ({ lastSeenByUser: {} }) as AlarmInboxState,
    }
  )
);

export const selectMarkSeen = (s: AlarmInboxStore) => s.markSeen;

export const selectLastSeenAt = (username: string | null) => (s: AlarmInboxStore) =>
  username == null ? NEVER_SEEN : (s.lastSeenByUser[username] ?? NEVER_SEEN);
